import Login from './components/Login.vue';
import Dasboard from './components/Dasboard.vue';
import Erorrpage from './components/Error.vue';
import Viewscore from './components/Viewscore.vue'
import Account  from './components/Account.vue'
import Vue from 'vue'
import VueRouter from 'vue-router'
import axios from 'axios'
import Vuex from "vuex"
Vue.use(VueRouter)
function guardMyroute(to, form, next){

    var access=window.localStorage.getItem('storedData');
    
      if (to.fullPath === '/score/dashboard') {

        if (access=='false' || access == null) {

          next('login');
        }else{

            next();
        }
      }
      if (to.fullPath === '/login') {

        if (access == 'true') {
          next('dashboard');
        }
    }
}

export default [
    {
         path:'/login',
         name:'login',
         component:Login
    },
    {
      path:'/account-info',
      name:'accountstudent',
      component:Account
 },
    {
       path:'',
       name:'login',
       component:Login,
     
    },
    
    {
        path:'/error-404',
        name:'error-404',
        component:Erorrpage

    },
    {
        path:'/score/dashboard',
        name:'dashboard',
        component:Dasboard
         
    },
      {
        path:'/view/score',
        name:'view-score',
        component:Viewscore
        
    },
    {
        path: '*',
        redirect: 'error-404',
    },
]
